const components = {
  History: () => import('@/qb/components/History/History'),
  Overview: () => import('@/qb/components/Overview'),
  QueriesRepositories: () => import('@/qb/components/Queries/QueriesRepositories'),
  QueryEditor: () => import('@/qb/components/Queries/QueryEditor'),
  DashboardsRepositories: () => import('@/qb/components/Dashboards/DashboardsRepositories'),
  DashboardEditor: () => import('@/qb/components/Dashboards/DashboardEditor'),
  DashboardPreview: () => import('@/qb/components/Dashboards/DashboardPreview'),
  Resources: () => import('@/qb/components/Resources/Resources'),
  Settings: () => import('@/qb/components/Settings/Settings'),
  RouterRedirectDataplantId: () => import('@/shared/RouterRedirectDataplantId')
}

const routes = [
  {
    path: '/',
    name: 'AM',
    component: components.RouterRedirectDataplantId,
    meta: {
      analytics: { category: 'dashboard' },
      ready: []
    }
  },
  {
    path: '/:dataplantId/',
    name: 'AM - Overview',
    display_name: 'searchbar.items.am.overview.display_name',
    description: 'searchbar.items.am.overview.description',
    searchable: true,
    component: components.Overview,
    meta: {
      analytics: { category: 'dashboard' },
      ready: ['qb_queries', 'qb_metas', 'qb_resources', 'qb_resources_metrics']
    }
  },
  {
    path: '/:dataplantId/queries',
    name: 'AM - Queries',
    display_name: 'searchbar.items.am.queries.display_name',
    description: 'searchbar.items.am.queries.description',
    searchable: true,
    component: components.QueriesRepositories,
    meta: {
      analytics: { category: 'listing' },
      title: (route, parent) => `Queries - ${parent(route, false)}`,
      ready: ['qb_repositories', 'qb_queries', 'qb_metas', 'qb_resources']
    }
  },
  {
    path: '/:dataplantId/query',
    name: 'AM - New Query',
    component: components.QueryEditor,
    meta: {
      analytics: { category: 'funnel' },
      title: (route, parent) => `Query - ${parent(route, false)}`,
      ready: ['qb_repositories', 'qb_queries', 'qb_metas', 'qb_resources']
    }
  },
  {
    path: '/:dataplantId/query/:id',
    name: 'AM - Edit Query',
    component: components.QueryEditor,
    meta: {
      analytics: { category: 'editor' },
      title: (route, parent) => `Query - ${parent(route, false)}`,
      ready: ['qb_repositories', 'qb_queries', 'qb_metas', 'qb_resources']
    }
  },
  {
    path: '/:dataplantId/dashboards',
    name: 'AM - Dashboards',
    display_name: 'searchbar.items.am.dashboards.display_name',
    description: 'searchbar.items.am.dashboards.description',
    searchable: true,
    component: components.DashboardsRepositories,
    meta: {
      analytics: { category: 'listing' },
      title: (route, parent) => `Dashboards - ${parent(route, false)}`,
      ready: ['qb_repositories', 'qb_dashboards', 'qb_queries']
    }
  },
  {
    path: '/:dataplantId/dashboard',
    name: 'AM - New Dashboard',
    component: components.DashboardEditor,
    meta: {
      analytics: { category: 'funnel' },
      title: (route, parent) => `Dashboard - ${parent(route, false)}`,
      ready: ['qb_repositories', 'qb_dashboards', 'qb_queries', 'qb_metas', 'qb_resources', 'iam_service_accounts', 'iam_roles', 'iam_users', 'iam_groups']
    }
  },
  {
    path: '/:dataplantId/dashboard/:id',
    name: 'AM - Edit Dashboard',
    component: components.DashboardEditor,
    meta: {
      analytics: { category: 'editor' },
      title: (route, parent) => `Dashboard - ${parent(route, false)}`,
      ready: ['qb_repositories', 'qb_dashboards', 'qb_queries', 'qb_metas', 'qb_resources', 'iam_service_accounts', 'iam_roles', 'iam_users', 'iam_groups']
    }
  },
  {
    path: '/:dataplantId/dashboard/:id/preview',
    name: 'AM - Dashboard Preview',
    component: components.DashboardPreview,
    meta: {
      analytics: { category: 'exploration' },
      fullscreen: true,
      title: (route, parent) => `Dashboard Preview - ${parent(route, false)}`,
      ready: ['qb_repositories', 'qb_dashboards', 'qb_queries', 'qb_metas', 'qb_resources']
    }
  },
  {
    path: '/:dataplantId/history',
    name: 'AM - History',
    display_name: 'searchbar.items.am.history.display_name',
    description: 'searchbar.items.am.history.description',
    searchable: true,
    component: components.History,
    meta: {
      analytics: { category: 'exploration' },
      title: (route, parent) => `History - ${parent(route)}`,
      ready: ['qb_repositories', 'qb_resources']
    }
  },
  {
    path: '/:dataplantId/resources',
    name: 'AM - Resources',
    component: components.Resources,
    meta: {
      analytics: { category: 'listing' },
      title: (route, parent) => `Resources - ${parent(route)}`,
      ready: ['qb_resources', 'qb_resources_metrics']
    }
  },
  {
    path: '/:dataplantId/settings',
    name: 'AM - Settings',
    display_name: 'searchbar.items.am.settings.display_name',
    description: 'searchbar.items.am.settings.description',
    searchable: true,
    component: components.Settings,
    meta: {
      analytics: { category: 'settings' },
      title: (route, parent) => `Settings - ${parent(route)}`,
      ready: ['qb_repositories']
    }
  },
  {
    path: '/:pathMatch(.*)',
    redirect: { name: 'AM' }
  }
]

export const basePath = 'am/'
export default routes
